import { useTheme } from "@mui/material";
interface WindowSidebarIconProps {
  fdTextColor?: string;
  symbolColor?: string;
  width?: string;
  height?: string;
  className?: string;
}
const WindowSidebarIcon = (props: WindowSidebarIconProps): JSX.Element => {
  const theme = useTheme();
  const {
    width = "59px",
    height = "52px",
  } = props ?? {};
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 59 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.5 51.875H6.5C3.32436 51.875 0.75 49.3006 0.75 46.125V5.875C0.75 2.69936 3.32436 0.125 6.5 0.125H52.5C55.6756 0.125 58.25 2.69936 58.25 5.875V46.125C58.25 49.3006 55.6756 51.875 52.5 51.875ZM23.75 11.625V46.125H52.5V11.625H23.75ZM6.5 11.625V46.125H18V11.625H6.5Z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
};

export default WindowSidebarIcon;
